module.exports = __webpack_public_path__ + "static/media/004-sun.68bf9d5f.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/weather/svg/004-sun.svg
// module id = 788
// module chunks = 0